export default "__VITE_ASSET__Bl_$uIv$__"